import { useMemo } from 'react';

import { useFlashOffers } from 'providers/FlashOffersProvider';

function useFlashOffer(offerId) {
  const { offers: flashOffers, tick } = useFlashOffers();

  const flashOffer = useMemo(() => {
    const entry = flashOffers?.get(Number(offerId));

    if (!entry) {
      return null;
    }

    const now = new Date(tick);
    const start = new Date(entry.startTime);
    const end = new Date(entry.endTime);

    if (now < start) {
      return {
        phase: 'pre-activation',
        targetDate: start,
        theme: entry.theme,
      };
    }

    if (now <= end) {
      return {
        phase: 'active',
        targetDate: end,
        theme: entry.theme,
      };
    }

    // Phase "ended" returns null — StopWatch should not render
    return null;
  }, [flashOffers, offerId, tick]);

  return flashOffer;
}

export default useFlashOffer;
